<header #pageHeader class="fixed-top">
  <nav>
    <img src="../../../assets/img/velmaral-banner.jpg" class="img-fluid header-img" alt="Event"
      (load)="onHeaderImageLoad()" decoding="async" />
  </nav>
</header>
<div class="bg-wrapper" #bgWrapper>
<div class="container-fluid" *ngIf="canShow === false && pageNotFound === false">
    <div class="row mt-3 mb-3">
      <p class="limited-seat text-center mt-2 mb-2">
        வேல்மாறல் வழிபாட்டு பதிவுக்கு இன்னும் <b>{{remainingCount}} இடங்கள்</b> மட்டுமே உள்ளன.
      </p>
    </div>

    <!-- Background -->
    <div class="d-flex justify-content-center py-4 px-2">

      <!-- White Card Container -->
      <div class="container form-card p-4">

        <div class="instruction-box p-3 my-3">
          <div class="text-center">
            <h4 class="mb-3 text-color">ஊர் (City): {{eventDetails?.city}}</h4>
            <h4 class="mb-3 text-color">தேதி (Date): {{eventDetails?.eventDate | date: 'dd/MM/yyyy' }}</h4>
            <h4 class="mb-3 text-color">இடம் (venue): {{eventDetails?.eventVenue}}</h4>
          </div>
        </div>

        <form [formGroup]="eventForm" (ngSubmit)="submitForm()" class="p-2" autocomplete="off">

          <!-- ======= NO PAYMENT WARNING CHECKBOX ======= -->
          <div class="mb-3">
            <h6 class="font-weight-bolder d-block text-danger">கீழே உள்ள தேர்வுப்பெட்டியை உறுதிப்படுத்தி,
              நிகழ்விற்கான உங்கள் விவரங்களை உள்ளிட தொடர்ந்து செயல்படவும். (Kindly check the checkbox and proceed to
              enter your details.)</h6>

            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="noScam" formControlName="noScam">
              <label class="form-check-label fw-bold" for="noScam">யாரிடமும் பணம் செலுத்தி ஏமாற மாட்டேன்</label>
            </div>

            <div *ngIf="eventForm.get('noScam')?.touched && eventForm.get('noScam')?.invalid" class="text-error mt-1">
              இந்த பொட்டியை டிக் செய்ய வேண்டும்.
            </div>
          </div>

          <div>
            <!-- ====== EMAIL ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">மின்னஞ்சல் (Email) *</label>
              <input type="email" class="form-control" formControlName="emailId"
                placeholder="உங்கள் மின்னஞ்சலை உள்ளிடவும்"
                autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                (blur)="duplicatePhoneandEmailCheck(eventForm.get('whatsappNumber')?.value, eventForm.get('emailId')?.value)"
                [ngClass]="{'is-invalid': eventForm.get('emailId')?.touched && eventForm.get('emailId')?.invalid}">

              <div *ngIf="eventForm.get('emailId')?.touched && eventForm.get('emailId')?.invalid"
                class="text-error mt-1">
                <span *ngIf="eventForm.get('emailId')?.errors?.['duplicateEmail']" class="text-error">
                  இந்த மின்னஞ்சல் ஏற்கனவே இந்த நிகழ்ச்சிக்காக பதிவுசெய்யப்பட்டுள்ளது.
                </span>
                <span *ngIf="eventForm.get('emailId')?.errors?.['required']">மின்னஞ்சல் தேவை.</span>
                <span *ngIf="eventForm.get('emailId')?.errors?.['email']">சரியான மின்னஞ்சல் வடிவம் இல்லை.</span>
                <span *ngIf="eventForm.get('emailId')?.errors?.['invalidDomain']">
                  gmail.com, zohomail.com, yahoo.com, hotmail.com, outlook.com மட்டுமே அனுமதிக்கப்படுகிறது.
                </span>
              </div>
            </div>



            <!-- ====== NAME ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">பெயர் (Name) (இடைவெளி இல்லாமல் பெயரை உள்ளிடவும்) (Enter Name Without Space)*</label>
              <input type="text" class="form-control" formControlName="name" (keypress)="allowOnlyName($event)"
              autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                [ngClass]="{'is-invalid': eventForm.get('name')?.touched && eventForm.get('name')?.invalid}">

              <div *ngIf="eventForm.get('name')?.touched && eventForm.get('name')?.invalid" class="text-error mt-1">
                பெயர் அவசியம் தேவை.
              </div>
              <div *ngIf="eventForm.get('name')?.errors?.['pattern']" class="text-error mt-1">
                A-Z எழுத்துகள் மற்றும் . மட்டும் அனுமதிக்கப்படும்.
              </div>
            </div>


            <!-- PHONE -->
            <div class="mb-3">
              <label class="form-label fw-bold">தொலைபேசி எண் (Contact Phone Number) *</label>

              <input type="text" class="form-control" formControlName="phoneNumber" maxlength="10"
                (input)="onPhoneInput($event, 'phoneNumber')" (keypress)="allowOnlyDigits($event)"
                (paste)="onPhonePaste($event, 'phoneNumber')"
                autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                [ngClass]="{'is-invalid': eventForm.get('phoneNumber')?.touched && eventForm.get('phoneNumber')?.invalid}" />

              <div *ngIf="eventForm.get('phoneNumber')?.touched && eventForm.get('phoneNumber')?.invalid"
                class="text-error mt-1">
                <span *ngIf="eventForm.get('phoneNumber')?.errors?.['required']">தொலைபேசி எண்ணை உள்ளிடவும்.</span>
                <span *ngIf="eventForm.get('phoneNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை உள்ளிடவும்.</span>
              </div>
            </div>


            <!-- WHATSAPP -->
            <div class="mb-3">
              <label class="form-label fw-bold">வாட்ஸ் ஆப் எண் (WhatsApp Number) *</label>

              <input type="text" class="form-control" formControlName="whatsappNumber" maxlength="10"
                autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                (input)="onPhoneInput($event,'whatsappNumber')" (keypress)="allowOnlyDigits($event)"
                (paste)="onPhonePaste($event,'whatsappNumber')"
                (blur)="duplicatePhoneandEmailCheck(eventForm.get('whatsappNumber')?.value, eventForm.get('emailId')?.value)"
                [ngClass]="{'is-invalid': eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid}" />

              <div *ngIf="eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid"
                class="text-error mt-1">
                <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['duplicatePhone']" class="text-error">
                  இந்த வாட்ஸ்அப் எண் ஏற்கனவே பதிவுசெய்யப்பட்டுள்ளது.
                </span>
                <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['required']">வாட்ஸ்அப் எண்ணை உள்ளிடவும்.</span>
                <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை
                  உள்ளிடவும்.</span>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">மாநிலம் / யூ பிரதேசம் (State / UT) *</label>

              <br>

              <select class="form-select form-select-lg p-1" formControlName="state">
                <option value="" disabled selected>Select any one</option>
                <option *ngFor="let s of statesList" [value]="s.value">
                  {{ s.label }}
                </option>
              </select>


              <div *ngIf="eventForm.get('state')?.touched && eventForm.get('state')?.invalid" class="text-error mt-1">
                மாநிலம் / யூ பிரதேசத்தை உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== DISTRICT ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">மாவட்டம் (District) *</label>

              <br>
              <select class="form-select form-select-lg p-1" formControlName="district">
                <option value="" disabled selected>Select any one</option>

                <option *ngFor="let d of districtList" [value]="d.value">
                  {{ d.label }}
                </option>
              </select>

              <div *ngIf="eventForm.get('district')?.touched && eventForm.get('district')?.invalid"
                class="text-error mt-1">
                மாவட்டத்தை உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== ADDRESS ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">முகவரி (Address) *</label>
              <textarea rows="2" class="form-control" formControlName="address"
                [ngClass]="{'is-invalid': eventForm.get('address')?.touched && eventForm.get('address')?.invalid}"
                autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"></textarea>
              <div *ngIf="eventForm.get('address')?.touched && eventForm.get('address')?.invalid"
                class="text-error mt-1">
                முகவரி தேவை.
              </div>
            </div>


            <!-- ====== AGE ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">வயது (Age) *</label>
              <input type="tel" class="form-control" formControlName="age" (keypress)="allowOnlyAge($event)"
                maxlength="3"
                autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false">
              <div *ngIf="eventForm.get('age')?.touched && eventForm.get('age')?.invalid" class="text-error mt-1">
                <span *ngIf="eventForm.get('age')?.errors?.['required']">வயதை உள்ளிடவும்.</span>
                <span *ngIf="eventForm.get('age')?.errors?.['pattern']">
                  வயது 1 முதல் 120 வரை இருக்க வேண்டும்.
                </span>
              </div>
            </div>


            <!-- ====== PHYSICALLY CHALLENGED ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">உடல் ஊனமுற்றவரா? (Physically challenged) *</label>

              <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="physically" value="Yes" id="phyYes">
                <label class="form-check-label" for="phyYes">Yes</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="physically" value="No" id="phyNo">
                <label class="form-check-label" for="phyNo">No</label>
              </div>

              <div *ngIf="eventForm.get('physically')?.touched && eventForm.get('physically')?.invalid"
                class="text-error mt-1">
                தயவுசெய்து ஒரு விருப்பத்தைத் தேர்வு செய்யவும்.
              </div>
            </div>


            <!-- ====== MAT CARRY RULE ====== -->
            <div class="instruction-box p-3 my-3">
              <p class="fw-bold mb-2">நிகழ்ச்சிக்கு வரும் பொழுது கண்டிப்பாக கீழே விரித்து அமர பாய் அல்லது துண்டு கொண்டு
                வர
                வேண்டும்.</p>
              <p class="fw-bold mb-2">கண்டிப்பாக தரையில் அமர்ந்து பூஜை செய்ய அனுமதி இல்லை.</p>

              <p class="fw-bold mb-2">When attending the event, it is mandatory to bring a mat, cloth, or any
                covering.</p>
              <p class="fw-bold mb-2">Sitting directly on the floor will not be allowed.</p>
            </div>


            <!-- ====== OPTIONAL CHECKBOX ====== -->
            <div class="mb-3">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="willBring" formControlName="willBring">
                <label class="form-check-label" for="willBring">கண்டிப்பாக கொண்டு வருவேன்</label>
              </div>
            </div>


            <!--&lt;!&ndash; ====== WILL ATTEND RADIO ====== &ndash;&gt;
            <div class="mb-3">
              <label class="form-label fw-bold d-block">
                இந்த நிகழ்ச்சிக்கு கண்டிப்பாக நான் கலந்து கொள்வேன்.<br>
                வர முடியாத சூழ்நிலையில் குழுவிற்கு முன்பே தெரிவிக்கவும்.<br><br>

                <span class="fw-bold">I will definitely attend this event.</span><br>
                If I am unable to come, I will inform the group in advance.
              </label>

              <div class="form-check">
                <input class="form-check-input" type="radio" id="attendYes" value="Yes" formControlName="willAttend">
                <label class="form-check-label" for="attendYes">கண்டிப்பாக வழிபாட்டில் கலந்து கொள்வேன்</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="radio" id="attendNo" value="No" formControlName="willAttend">
                <label class="form-check-label" for="attendNo">இல்லை, என்னால் வர இயலாது</label>
              </div>

              <div *ngIf="eventForm.get('willAttend')?.touched && eventForm.get('willAttend')?.invalid"
                   class="text-error mt-1">
                தயவுசெய்து ஒரு விருப்பத்தைத் தேர்வு செய்யவும்.
              </div>
            </div>-->


            <!-- ====== PARTICIPANTS DROPDOWN ====== -->
            <div class="border p-2">
              <div class="mb-3 ">
                <h5 class="form-label fw-bold text-danger">Note : மேலே உங்களது பெயர் மற்றும் விவரங்கள் பதிவு
                  செய்யப்பட்டது.<br>
                  இனி உங்களுடன் வருபவர்களின் விவரங்களை பூர்த்தி செய்யவும் .
                  <br> இல்லையெனில் பூஜியத்தை தேர்வு செய்து படிவத்தை சமர்ப்பிக்கவும்
                </h5>
              </div>
              <div class="mb-3 ">
                <label class="form-label fw-bold">உடன் வருபவர்களின் எண்ணிக்கை (Participants count)</label>
                <br>
                <select class="form-select form-select-lg p-1" formControlName="participants">
                  <option value="" disabled selected>Select the counts</option>

                  <option [ngValue]="0" [disabled]="0 > maxSelectable">0</option>
                  <option [ngValue]="1" [disabled]="1 > maxSelectable">1</option>
                  <option [ngValue]="2" [disabled]="2 > maxSelectable">2</option>
                  <option [ngValue]="3" [disabled]="3 > maxSelectable">3</option>
                </select>


              </div>


              <div formArrayName="participantInputs">

                <div *ngFor="let row of members.controls; let i = index" [formGroupName]="i" class="row mb-2">

                  <!-- Name -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">பெயர் (Name) (Enter Name Without Space)* {{ i + 1 }}</label>

                    <input type="text" formControlName="participantName" class="form-control"
                      (keypress)="allowOnlyName($event)"
                      autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                      [ngClass]="{'is-invalid': row.get('participantName')?.touched && row.get('participantName')?.invalid}">

                    <div class="invalid-feedback"
                      *ngIf="row.get('participantName')?.touched && row.get('participantName')?.invalid">
                      <span *ngIf="row.get('participantName')?.errors?.['required']">பெயர் அவசியம் தேவை.</span>
                      <span *ngIf="row.get('participantName')?.errors?.['minlength']">குறைந்தது 3 எழுத்துகள்
                        தேவை.</span>
                      <span *ngIf="row.get('participantName')?.errors?.['sameAsMain']" class="text-danger">
                        மேலே ஏற்கனவே உள்ளிடப்பட்ட பெயரை உள்ளிட வேண்டாம்.
                      </span>
                    </div>
                  </div>

                  <!-- Phone -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">தொலைபேசி எண் (Contact Phone Number) {{ i + 1 }}</label>

                    <input type="text" formControlName="whatsappNumber" class="form-control"
                      (keypress)="allowOnlyDigits($event)"
                      autocomplete="new-password" autocorrect="off" autocapitalize="off" spellcheck="false"
                      [ngClass]="{'is-invalid': row.get('whatsappNumber')?.touched && row.get('whatsappNumber')?.invalid}"
                      maxlength="10" minlength="10">

                    <div class="invalid-feedback"
                      *ngIf="row.get('whatsappNumber')?.touched && row.get('whatsappNumber')?.invalid">
                      <span *ngIf="row.get('whatsappNumber')?.errors?.['required']">தொலைபேசி எண்ணை உள்ளிடவும்.</span>
                      <span *ngIf="row.get('whatsappNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை
                        உள்ளிடவும் (6–9 தொடங்க வேண்டும்).
                      </span>
                      <span *ngIf="row.get('whatsappNumber')?.errors?.['sameAsMainPhone']" class="text-danger">
                        மேலே ஏற்கனவே உள்ளிட்ட தொலைபேசி எண்ணை உள்ளிட வேண்டாம்.
                      </span>
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <!-- ====== SUBMIT BUTTON ====== -->
            <div class="text-center">
              <button class="btn btn-danger btn rounded-pill px-5 mt-3 " [disabled]="eventForm.invalid">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="closed-wrapper d-flex justify-content-center align-items-center overflow-y" #bgWrapper *ngIf="canShow">
  <div class="closed-card animate__animated animate__fadeIn">
    <div class="icon-circles mb-3">
      <i class="bi bi-x-circle-fill"></i>
    </div>

    <h3 class="tamil-title">பதிவு முடிந்துவிட்டது</h3>
    <h6 class="tamil-text">
      இந்தப் படிவம் தற்போது நிறைவடைந்து, இனி பதில்கள் ஏற்கப்படுவதில்லை. உங்கள் ஆர்வத்திற்கு நன்றி.<br>
      <br>  
      முருகா சரணம்
    </h6>

    <hr>

    <h4 class="eng-title">Form Closed</h4>
    <h6 class="eng-text">
      The form is now closed and no longer accepting responses. Thank you for your interest.<br>
      <br>
      Muruga Saranam.
    </h6>
    <!-- <h5 clas="eng-title fw-bold">Contact Us: +91 7339663756</h5> -->
  </div>
</div>

<div *ngIf="pageNotFound" #bgWrapper
     class="d-flex justify-content-center align-items-center vh-100">
  <img src="../../../assets/img/page-not-found.png" alt="Page Not Found" class="img-fluid">
</div>


<!-- <footer class="real -footer mt-5 pt-2 pb-2">
  <div class="text-white py-3">
    <div class="container">
      <div class="row d-flex justify-content-between align-items-center text-center">
        <div class="col-lg-6"><p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href="" class="text-white text-decoration-none font-weight-bold">
          வேல் மாறல் சேவா அறக்கட்டளை.
        </a></p></div>
        <div class="col-lg-6 justify-content-between align-items-center text-center"><p
           class="mb-0">Designed &amp; Developed by <a
           href="https://cktechsoln.in/" target="_blank"
          class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd Madurai.</a></p></div>
      </div>
    </div>
  </div>

</footer> -->

<footer class="real-footer">
  <div class="text-white py-1">
    <div class="container-fluid">
      <div class="row d-flex justify-content-between align-items-center text-center">

        <div class="col-lg-4 col-md-6 col-12 mb-2">
          <p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href=""
              class="text-white text-decoration-none font-weight-bold">
              வேல்மாறல் சேவா அறக்கட்டளை.
            </a></p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
          <p class="mb-0">Designed &amp; Developed by <a href="https://cktechsoln.in/" target="_blank"
              class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd Madurai.</a></p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
          <p class="mb-0"><a routerLink="/terms" target="_blank"
              class="text-white text-decoration-none font-weight-bold">Terms & Conditions</a> | <a routerLink="/privacy"
              target="_blank" class="text-white text-decoration-none font-weight-bold">Privacy</a></p>
        </div>
      </div>
    </div>
  </div>

</footer>

<!-- Ticket Image -->
<div class="ticket-wrapper" id="ticket-wrapper" *ngIf="ticketDetails">

  <div class="image-container">

    <img src="assets/img/velmaral-event-qr.jpg" class="ticket-image" />

    <h4 class="name">{{ ticketDetails?.name }}</h4>

    <p class="name mt-5">{{ ticketDetails?.emailId }}</p>


    <img *ngIf="qrCodeImg" [src]="qrCodeImg" class="qrCode" />


    <p class="ticket">{{ ticketDetails?.audienceDetails[0]?.groupTicketSeq }}</p>

  </div>
</div>